import { useEffect } from "react";

function ExternalRedirect() {
  useEffect(() => {
    window.location.replace("https://prabhuchat.com");
  }, []);

  return null;
}

export default ExternalRedirect;